import { render, staticRenderFns } from "./DemoHeader.vue?vue&type=template&id=43a67093&"
import script from "./DemoHeader.vue?vue&type=script&lang=js&"
export * from "./DemoHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports